import { render, staticRenderFns } from "./UserConfirm.vue?vue&type=template&id=0d1bce76&scoped=true"
import script from "./UserConfirm.vue?vue&type=script&lang=js"
export * from "./UserConfirm.vue?vue&type=script&lang=js"
import style0 from "./UserConfirm.vue?vue&type=style&index=0&id=0d1bce76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bce76",
  null
  
)

export default component.exports